import { render, staticRenderFns } from "./flipcard-component.vue?vue&type=template&id=4b879e10&scoped=true&"
import script from "./flipcard-component.vue?vue&type=script&lang=ts&"
export * from "./flipcard-component.vue?vue&type=script&lang=ts&"
import style0 from "./flipcard-component.vue?vue&type=style&index=0&id=4b879e10&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b879e10",
  null
  
)

export default component.exports